import { Icon, P3, P4 } from '@moneymade/moneymade-ui'
import ImgLazy from 'components/ui/ImgLazy/ImgLazy'
import PropTypes from 'prop-types'

import styles from './PersonCard.module.scss'

const PersonCard = ({ linkedin, name, photo, position, surname, twitter }) => (
  <div className={styles.PersonCard}>
    <div style={{ width: 150, height: 150 }}>
      <ImgLazy src={photo} alt="avatar" width={150} height={150} className={styles.Logo} />
    </div>
    <P3>{`${name} ${surname}`}</P3>
    <div className={styles.Position}>
      <P4>{position}</P4>
    </div>
    <div className={styles.Links}>
      {twitter ? (
        <a href={twitter} className={styles.Button} target="_blank" rel="noreferrer">
          <Icon icon="icon-twitter" size={20} />
        </a>
      ) : null}
      {linkedin ? (
        <a href={linkedin} className={styles.Button} target="_blank" rel="noreferrer">
          <Icon icon="icon-linkedIn" size={20} />
        </a>
      ) : null}
    </div>
  </div>
)

PersonCard.propTypes = {
  linkedin: PropTypes.string,
  name: PropTypes.string,
  photo: PropTypes.string,
  position: PropTypes.string,
  surname: PropTypes.string,
  twitter: PropTypes.string
}

PersonCard.defaultProps = {
  linkedin: '',
  name: '',
  position: '',
  photo: '',
  surname: '',
  twitter: ''
}

export default PersonCard
